import { Formik, Form, FormikProps } from "formik";
import { Spinner } from "react-bootstrap";
import { useCallback, useEffect } from "react";

import Panel from "../../Panel";
import { Heading, Intro } from "../../Typography";
import ProfileFormFields from "../../EntryFormFields";
import PictureInput from "../../../../../components/PictureInput";
import { Field, SubmitButton } from "../../../../../components/forms";
import useProfileScreen from "./useProfileScreen";
import useLocation from "../../../../../hooks/useLocation";
import { ProfileValues } from "../../hooks/useProfileForm";

const ProfileScreen = () => {
  const {
    profile,
    initialValues,
    onSubmit,
    schema,
    canChangeCategory,
    competition,
    canEnterCompetition,
    canEnterCompetitionReason,
    isLeagueEntryLoading,
    setCompetitorNumber,
    existingCompetitorData,
  } = useProfileScreen();

  const location = useLocation<{ didJustRegister: boolean }>();
  const didJustRegister = location.state?.didJustRegister || false;

  const renderForm = useCallback(
    // eslint-disable-next-line react/display-name
    (props: FormikProps<ProfileValues>) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useEffect(() => {
        if (
          existingCompetitorData &&
          !props.values.firstName &&
          !props.values.lastName &&
          !props.values.category
        ) {
          props.setFieldValue("firstName", existingCompetitorData.firstName);
          props.setFieldValue("lastName", existingCompetitorData.lastName);
          props.setFieldValue("category", existingCompetitorData.category);
        }
      }, [props]);
      return (
        <Form>
          <Field name="profilePicture" className="text-center">
            <PictureInput />
            <div style={{ fontSize: 13 }} className="fst-italic">
              (Optional - will be displayed on leaderboards)
            </div>
          </Field>
          <ProfileFormFields
            withProfile={!didJustRegister}
            competition={competition}
            canChangeCategory={canChangeCategory}
            setCompetitorNumber={setCompetitorNumber}
          />
          <SubmitButton>Enter Competition</SubmitButton>
        </Form>
      );
    },
    [
      existingCompetitorData,
      canChangeCategory,
      competition,
      didJustRegister,
      setCompetitorNumber,
    ]
  );

  if (canEnterCompetition) {
    return (
      <Panel>
        <Heading>{profile ? `Welcome, ${profile.firstName}` : <br />}</Heading>
        <Intro>
          {didJustRegister
            ? "Which category are you competing in today?"
            : "We need some details to display you on the leaderboards and your scorecard. These will be visible to everyone, no silly names please!"}
        </Intro>
        {competition && profile && !isLeagueEntryLoading ? (
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={schema}
          >
            {renderForm}
          </Formik>
        ) : (
          <Spinner animation="border" />
        )}
      </Panel>
    );
  } else if (canEnterCompetition === false) {
    return (
      <Panel>
        <Heading>Entry not allowed</Heading>
        <Intro>{canEnterCompetitionReason}</Intro>
      </Panel>
    );
  } else {
    return (
      <Panel>
        <div className="h-200 d-flex align-items-center justify-content-center">
          <Spinner animation="border" />
        </div>
      </Panel>
    );
  }
};

export default ProfileScreen;
